import useStaffAttendance from "./use-staff-attendance";
import useStaffCheckInHistory from "./use-staff-check-in-history";
import useStaffCheckQr from "./use-staff-check-qr";
import useStaffWorkerSessions from "./use-staff-worker-sessions";
import useStaffWorkSessionsExportExcel from "./use-staff-work-sessions-export-excel";


const StaffManagementHooks = {
    useStaffAttendance,
    useStaffCheckInHistory,
    useStaffCheckQr,
    useStaffWorkerSessions,
    useStaffWorkSessionsExportExcel,
};

export default StaffManagementHooks;
